import { useViewjobProctorAllocation } from "../../../../proctor/__generated__/ViewjobProctorContext";
import {
  CareerScoutAlwaysAware,
  CareerScoutDynamicConvoStartersVjTst,
  CareerScoutStartersRandomOrderingVjTog,
} from "../../../../proctor/__generated__/ViewjobProctorSpecifications";

export const CAREER_SCOUT_ALWAYS_AWARE_BUCKETS = {
  MATCH_SECTION: CareerScoutAlwaysAware.buckets.Matchsection,
  SEPARATE: CareerScoutAlwaysAware.buckets.Separate,
  SCROLL: CareerScoutAlwaysAware.buckets.Scroll,
  ASK: CareerScoutAlwaysAware.buckets.Ask,
} as const;

export const useCareerScoutAlwaysAwareBucket = () =>
  useViewjobProctorAllocation(CareerScoutAlwaysAware).value;

export const useCareerScoutStartersRandomOrdering = (): boolean =>
  useViewjobProctorAllocation(CareerScoutStartersRandomOrderingVjTog).value > 0;

/**
 * RN-7499: swaps the three static starters for the job-aware dynamic pool.
 *
 * Scoped to the two section placements of `career_scout_always_aware`
 * (`matchSection` and `separate`). The `scroll` and `ask` buckets keep the
 * static starters by product decision, so this hook is not consulted there.
 */
export const useCareerScoutDynamicConvoStartersEnabled = (): boolean =>
  useViewjobProctorAllocation(CareerScoutDynamicConvoStartersVjTst).value >
  CareerScoutDynamicConvoStartersVjTst.buckets.Control;
